//
// Module for Benefit Estimate factors tab
//
rs.module("ui/controls/content/benefitestimatetabs/drop",

    ["controls/data/grid"],

    function (gridModule) {

        // Initialize the module
        function initialize(jsSelectors, ajaxUrls) {

            var dropTab = $.js(jsSelectors.dropTab);

            var benefitEstimateKeyInput = dropTab.js(jsSelectors.benefitEstimateKeyInput);

            var dropTransactionsView = dropTab.js(jsSelectors.dropTransactionsView);

            var paymentOptionsFilter = dropTab.js(jsSelectors.paymentOptionsFilter);
            var paymentOptionSelect = paymentOptionsFilter.js(jsSelectors.paymentOptionSelect);
            var loadingSpinner = paymentOptionsFilter.js(jsSelectors.loadingSpinner);

            paymentOptionSelect.change(updateDropTransactionsGrid);

            // Update the drop transactions for the provided payment option
            function updateDropTransactionsGrid() {
                loadingSpinner.show();

                $.get(ajaxUrls.getDropTransactionsGridData,
                    {
                        benefitEstimateKey: benefitEstimateKeyInput.val(),
                        payOptionKey: paymentOptionSelect.val()
                    },
                    function (html) {
                        dropTransactionsView.html(html);
                    })
                    .always(function () {
                        loadingSpinner.hide();
                    });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    });